/** Системные события (native → web). Доменные события мини-апп объявляет отдельно. */
export const SYSTEM_EVENTS = {
  Init: 'init',
  NavigationFocus: 'navigation.focus',
  NavigationBlur: 'navigation.blur',
  BackPressed: 'back.pressed',
  ThemeChanged: 'theme.changed',
  LocaleChanged: 'locale.changed',
  AuthChanged: 'auth.changed',
  AppStateChanged: 'appState.changed',
  KeyboardChanged: 'keyboard.changed',
  TabBarPressed: 'tabBar.pressed',
  SsoAuthorized: 'sso.authorized'
} as const;

export type SystemEventName =
  (typeof SYSTEM_EVENTS)[keyof typeof SYSTEM_EVENTS];

export type ColorSchemeMode = 'light' | 'dark';

export interface SafeAreaInsets {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

/**
 * Контекст, который native шлёт в web первым событием `init` (после `bridge.ready`).
 * `theme` — непрозрачное дерево токенов дизайн-системы (web потребляет структурно).
 */
export interface InitContext {
  protocolVersion: number;
  miniApp: { id: string };
  platform: string;
  mode: ColorSchemeMode;
  theme: Record<string, unknown>;
  locale: string;
  insets: SafeAreaInsets;
  featureFlags: Record<string, boolean>;
  auth: { isAuthenticated: boolean };
  webProperties?: {
    city: { uuid: string; name: string };
    initialPath?: string;
    monthlyPayment?: number;
    term?: number;
    downPaymentAmount?: number;
  };
}

/** Типы payload системных событий. */
export interface SystemEventPayloads {
  init: InitContext;
  'navigation.focus': null;
  'navigation.blur': null;
  'back.pressed': null;
  'theme.changed': { mode: ColorSchemeMode; theme: Record<string, unknown> };
  'locale.changed': { locale: string };
  'auth.changed': { isAuthenticated: boolean };
  'appState.changed': { state: string };
  'keyboard.changed': { visible: boolean; height: number };
  'tabBar.pressed': { id: string };
  /**
   * Одноразовый SSO-код для бэкенда мини-аппа (PKCE). На маунте пушится ТОЛЬКО если суперапп-сессия
   * уже активна (без UI). Иначе web сам запрашивает код экшеном `sso.authorize` (RPC) при 401/проактивно —
   * тогда native при необходимости триггерит вход (код-пароль/биометрия). Web меняет
   * {authorizationCode, codeVerifier} на свою сессию через свой бэкенд.
   */
  'sso.authorized': {
    authorizationCode: string;
    codeVerifier: string;
    expiresInSeconds: number;
  };
}
